import React, { useState, useEffect } from 'react'

// Translation
import { useTranslation } from 'react-multi-lang'

// Redux
import { useDispatch, useSelector } from 'react-redux'

// Gird system
import { Col, Row } from 'react-grid-system'

// Components
import Modal from '../../../components/Modal/Modal'
import { InputField, SelectField } from '../../../components/FormElements/FormElements'

import { SuccessMark, WhiteboxLoader } from '../../../components/Loader/Loader'
import { servicePricingState, servicePricingSlice, select, glass } from './ServicePricingSlice'
import { glassWorkPrice, servicesSlice,servicesState } from '../ServicesSlice'
import { useNotification } from '../../../services/usenotification'
import { havePermission } from '../../../services/hoc/permissions'
import { Divider } from '@mui/material'

import { useAPI } from '../../../services/hoc/useAPI'

export default ({close}:{close:Function}) => {

    // Translation
    const t = useTranslation()
    const {alert,alertError500}=useNotification()
    // Redux
    const dispatch = useDispatch()
    const state = useSelector((state: { service_pricing: servicePricingState }) => state.service_pricing)
    const servicesState = useSelector(
        (state: { services: servicesState }) => state.services,
      );
const ENDPOINTS = useAPI()


    const [materialOptions, setMaterialsOptions] = useState<select[]>([])

    const toggle = () => {
        dispatch(servicePricingSlice.actions.setIsOpen(!state.isOpen))
        dispatch(servicePricingSlice.actions.init())
        close()
    }

    // Fetch Data
    const fetchData = (page: number, page_size: number = 10) => {
        dispatch(servicePricingSlice.actions.setIsLoading(true))

        ENDPOINTS.glassWorks().glassNotPriced({ id: servicesState.service?.id })
            .then((response: any) => {
                let materials: glass[] = response.data.data[0].notpriced.map((material: any): glass => ({
                    id: material.id,
                    name: material.name,
                    code: material.code
                }))

                let options: select[] = response.data.data[0].notpriced.map((material: any): select => ({
                    label: material.name,
                    value: material.id
                }))

                setMaterialsOptions(options);


                dispatch(servicePricingSlice.actions.setIsLoading(false))
                dispatch(servicePricingSlice.actions.addMaterials(materials))
               
            })
            .catch((error:any)=>{
                dispatch(servicePricingSlice.actions.setIsLoading(false))
                alertError500(error)
            })

    }
    const submit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault()
     
        if (!Boolean (servicesState.service?.id) || state.prices.length ===0 || !havePermission("Show Glass Not Priced")) return
   
        let thePrices=state.prices.map(ele=> ({...ele,glass_work_id:servicesState.service?.id}))
        dispatch(servicePricingSlice.actions.setIsLoading(true))
        ENDPOINTS.pricing().addGlassWorkPrices({ glass_work_id: servicesState.service?.id
            , prices: thePrices })
        .then((response: any) => {


            let glassWorkPrices: glassWorkPrice[] = response.data.data;
           
            dispatch(servicesSlice.actions.addGlassWorkPrices(glassWorkPrices))
            dispatch(servicePricingSlice.actions.setIsLoading(false))
            dispatch(servicePricingSlice.actions.setIsSuccess(true))
            setTimeout(() => {
                toggle()
                dispatch(servicePricingSlice.actions.setIsOpen(false))
            }, 1000);
        })
        .catch((error:any)=>{
            dispatch(servicePricingSlice.actions.setIsLoading(false))
            alertError500(error)
        })
    }

useEffect(()=>{

  if(!state.isLoading && havePermission("Show Glass Not Priced")) {
  
     fetchData(1)
    }
},[])
    // First fetch
    useEffect(() => {
        // if (!state.isLoaded && !state.isFetching)
        if(!state.isLoading)  fetchData(1)
    }, [state.service])

    return (
        <Modal open={state.isOpen} toggle={toggle}>

            {state.isLoading ? <WhiteboxLoader /> : ""}

            {state.isSuccess ? <SuccessMark /> : ""}

            <h2 className="text-center" style={{ margin: "0 0 20px" }}>{t("pricing")}</h2>

            <form onSubmit={submit} style={{ width: "450px" }}>

                {
                    state.prices.map((price, index) => (
                        <div className="attribute" key={index}>
                            <div className="attribute-fields" style={state.prices.length > 1 ? {} : { padding: 0 }}>
                                <Row style={{marginBlock:'5px'}}>
                                    <Col xs={12}>
                                        <Col md={12} style={{margin:'0 auto'}}>
                                            <SelectField
                                                onMenuOpen={havePermission("Show Glass Not Priced")? ()=>{}:
                                            ()=>{
                                                alert({en:"You don't have permission to show not priced Glass",ar:
                                            "لا تملك صلاحيات عرض المواد غير المسعرة"},"info")
                                            }}
                                                placeholder={t("choose_material")}
                                                options={materialOptions}
                                                value={materialOptions.find(option => option.value === price.glass_id)}
                                                onChange={(option: { value: string }) => 
                                                dispatch(servicePricingSlice.actions.setMaterial({ index, value: option.value }))}
                                            />
                                        </Col>
                                    </Col>
                                    <Col xs={12} >
                                        <Col md={12} style={{margin:'0 auto'}}>
                                            <InputField
                                                placeholder={t("price")}
                                                type="number"
                                                label={t("price")}
                                                value={state.prices[index].price}
                                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                                    dispatch(servicePricingSlice.actions.setPriceValue({ index, value: e.target.value }));
                                                }}
                                            // error={ showErrors && !attribute.hint ? t("required_error") : "" }
                                            />
                                        </Col>
                                    </Col>
                                    <Col xs={12}>
                                        <Divider variant='middle' sx={{background:'lightgray'}}  />
                                    </Col>
                                </Row>
                            </div>
                            {state.prices.length > 1 ? <i className="icon-delete" onClick={
                                () => {
                                   
                                    dispatch(servicePricingSlice.actions.deletePrice(index))
                                }
                            }></i> : ""}
                        </div>
                    ))
                }

                <div className="text-left">
                    <button className="button bg-white color-gold margin-top-30"
                        onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
                            e.preventDefault()
                            dispatch(servicePricingSlice.actions.set([{ price: "0", glass_work_id: `${state.service?.id}` }]))
                        }}><i className='icon-plus'></i></button>
                </div>

                <button className="button round bg-gold color-white margin-top-20" style={{ padding: "0 80px", marginBottom: 5 }} >{t("submit")}</button>

            </form>

        </Modal>
    );
}